<div class="header-detail">
  <div *ngIf="isDisney" class="background-cover">
    <div class="castle-container">
      <div class="castle"></div>
    </div>
    <div class="back-stars"></div>
  </div>
  <div class="content mb-grid-container-full mb-grid-row">
    <div class="mb-grid-col-4 mb-grid-col-12-tb mb-grid-col-12-dt container">
      <div class="am-ctn detail-header-inner">
        <div class="header-menu" *ngIf="!isMobile">
          <detail-menu
            (tabClicked)="menuClicked($event)"
            [actualContainer]="actualContainer"
            [scrollMenu]="scrollMenu"
            [disableRooms]="isLanding || busy"
            [disableReviews]="disableMenuReviews"
            [disableRelated]="disableMenuRelated"
            [error]="error"
          ></detail-menu>
        </div>
        <div class="mb-grid-container-full mb-grid-row">
          <div
            class="mb-grid-col-4 mb-grid-col-12-tb mb-grid-col-12-dt mb-grid-row slider-container slider-with-pricebox"
            [ngClass]="chain"
          >
            <ng-template #photosMobile>
              <mb-carousel
                backgroundImage
                class="mb-grid-col-4"
                [images]="images$ | async"
                [infinity]="false"
                [showNumbers]="true"
              ></mb-carousel>
            </ng-template>
            <ng-container *ngIf="!isMobile; else photosMobile">
              <slider
                class="mb-grid-col-12-tb mb-grid-col-12-dt"
                [items]="hotelStaticInfo.images"
                [itemsCant]="1"
                [showLabel]="true"
                [showVertical]="true"
                (clickShowGallery)="showGallery($event)"
              ></slider>
            </ng-container>
            <ng-container *ngIf="isMobile">
              <ng-template #noDisney>
                <outstanding-promo
                  *ngIf="offer"
                  [section]="'detail'"
                  [offer]="offer"
                ></outstanding-promo>
              </ng-template>
              <div
                class="hotel-disney-badge mb-grid-col-4"
                *ngIf="isDisney; else noDisney"
              >
                <mb-badge color="dark" size="small">
                  <mb-icon icon="disney"></mb-icon>
                  <span i18n="@@hotel_disney">Hotel Disney</span>
                </mb-badge>
              </div>
              <div class="show-on-mobile relative-position mb-grid-col-4">
                <hotel-intro
                  [isLanding]="isLanding"
                  [chain]="chain"
                  [rating]="rating"
                ></hotel-intro>
                <div
                  class="experts-components-container"
                  [ngClass]="{ 'is-disney': isDisney }"
                >
                  <div class="experts-share-container" (click)="trackExpertsShareEvent()">
                    <am-experts-share
                      [productDetail]="currentUrl"
                      [size]="'sm'"
                      [locale]="locale"
                    ></am-experts-share>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngIf="!isMobile" class="mb-grid-container-full mb-grid-row header-intro">
          <ng-template #noDisney>
            <span>
              <outstanding-promo
                *ngIf="offer"
                [section]="'detail'"
                [offer]="offer"
              ></outstanding-promo>
            </span>
          </ng-template>
          <span *ngIf="isDisney; else noDisney">
            <mb-badge color="dark" size="small">
              <mb-icon icon="disney"></mb-icon>
              <span i18n="@@hotel_disney">Hotel Disney</span>
            </mb-badge>
          </span>
          <div class="header-container mb-grid-col-12-tb mb-grid-col-12-dt">
            <hotel-intro
              [isDisney]="isDisney"
              [isLanding]="isLanding"
              [chain]="chain"
              [rating]="rating"
            ></hotel-intro>
            <div
              class="experts-components-container"
              [ngClass]="{ 'is-disney': isDisney }"
            >
              <am-trips-add-product
                *ngIf="isExperts"
                [productType]="productType"
                [product]="tripFavoriteData"
                [currencyCode]="currencyCodeToTripFavorite"
              ></am-trips-add-product>
              <div class="experts-share-container" (click)="trackExpertsShareEvent()">
                <am-experts-share
                  [productDetail]="currentUrl"
                  [size]="'sm'"
                  [locale]="locale"
                ></am-experts-share>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
